import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2f9md2aaq7: FaireBrandEntity = {
  token: "b_2f9md2aaq7",
  type: "brand",
  name: "Lucky Link",
  avatarUrl:
    "https://cdn.faire.com/fastly/6cd0befad4bf6bcac69fcef33a460e5e3da46588230a39d867c8197c3f60c10e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/48d3243063b8ec1c9da8157993297aa115016b3ab6b5a7ef17c1ae9cd7937ec7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6cd0befad4bf6bcac69fcef33a460e5e3da46588230a39d867c8197c3f60c10e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/48d3243063b8ec1c9da8157993297aa115016b3ab6b5a7ef17c1ae9cd7937ec7.png",
  location: "Pickerington, OH, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 19,
  isTopShop: true,
  isInsider: true,
  description:
    "Hey there! Welcome to Lucky Link – where a lifelong love for fashion design collided headfirst with the chaos and joy of becoming a new mom to an absolutely awesome little dude. Yep, that's us in a nutshell!\n\nOur story takes a sharp turn from the fancy world of big corporate design to tackle the real need for clothes that are not just stylish but downright fun and practical for toddlers aged 6 months to 5T. Because let's face it, every little guy deserves to rock some seriously cool threads!\n\nLucky Link is our way of making sure your kiddo's wardrobe is not just about keeping them covered but turning heads while doing it. It's about celebrating the wild, adorable, and downright awesome nature of childhood!\n\nOUR INSPIRATION\n Meet the heart and soul behind Lucky Link – our little superhero, Lincoln. At just one year old, he faced a diagnosis of epilepsy that flipped our world upside down. But let us tell you, this kiddo showed us what true strength, courage, and an infectious spirit of joy look like, even in the face of challenges.\n\nLucky Link isn't just a brand; it's a tribute to Lincoln's resilience and the incredible journey we've shared as a family. He's the reason we're all about spreading good vibes and celebrating life's little victories – because, honestly, every day with Lincoln feels like a win.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:05.323Z",
    importedBy: "entity-db-cli",
  },
};
